import { Static, String, Object, Optional, Number, Record, Union, Literal } from '@sinclair/typebox';

const BoundFarePrice = Union([
  Object({
    type: Literal('revenue'),
    totalPrice: Number(),
  }),
  Object({
    type: Literal('points'),
    points: Number(),
  }),
]);

const BoundFares = Record(
  String(),
  Object({
    associatedLowestFares: Optional(
      Record(String(), Object({ price: BoundFarePrice, productName: String(), recId: Number() }))
    ),
    price: BoundFarePrice,
    productName: String(),
    recId: Number(),
  })
);

export const RebookingCalendarOffersResponse = Object({
  outbound: BoundFares,
  inbound: BoundFares,
});

export type RebookingCalendarOffersResponse = Static<typeof RebookingCalendarOffersResponse>;
export type RebookingCalendarFarePrice = Static<typeof BoundFarePrice>;
